
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solarspeicher",
      function () {
        return require("private-next-pages/solarspeicher/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solarspeicher"])
      });
    }
  